// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".women-reactivation-page[data-v-437ef1d6] .landingpage-hero-description,.women-reactivation-page[data-v-437ef1d6] .landingpage-hero-title{--text-opacity:1;color:#333;color:rgba(51,51,51,var(--text-opacity))}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
